import { LoaderCircle } from "lucide-react";

export function Button({
  children,
  variant = "secondary",
  size = "md",
  icon: Icon,
  loading = false,
  disabled = false,
  className = "",
  type = "button",
  ...props
}) {
  const LeadingIcon = loading ? LoaderCircle : Icon;
  return (
    <button
      type={type}
      className={`ui-button ui-button--${variant} ui-button--${size} ${className}`}
      {...props}
      disabled={loading || disabled}
      aria-busy={loading || undefined}
    >
      {LeadingIcon ? <LeadingIcon size={size === "sm" ? 15 : 17} className={loading ? "is-spinning" : ""} /> : null}
      <span>{children}</span>
    </button>
  );
}

export function IconButton({
  label,
  icon: Icon,
  size = "md",
  className = "",
  loading = false,
  disabled = false,
  ...props
}) {
  return (
    <button
      type="button"
      className={`ui-icon-button ui-icon-button--${size} ${className}`}
      aria-label={label}
      title={label}
      {...props}
      disabled={loading || disabled}
      aria-busy={loading || undefined}
    >
      <Icon size={size === "sm" ? 15 : 18} className={loading ? "is-spinning" : ""} />
    </button>
  );
}
